<template>
    <v-flex>
        <v-data-table
            :headers="content.headers"
            :items="content.body"
            :pagination.sync="pagination"
            item-key="name"
            :rows-per-page-items="[10]"
            hide-actions
            sort-icon="keyboard_arrow_down"
            class="table-list"
        >
            <template slot-scope="props" slot="headers">
                <tr>
                    <template
                        v-for="header in props.headers"
                    >
                        <th v-if="!header.inner_items"
                            :key="header.text"
                            :class="['column sortable', pagination.descending ? 'desc' : 'asc',
                                     header.value === pagination.sortBy ? 'active' : '']"
                            @click="changeSort(header.value)"
                        >
                            {{ header.text }}
                            <v-icon small>keyboard_arrow_up</v-icon>
                        </th>
                        <th v-else :key="header.text" :colspan="header.inner_items.length" class="pa-0">
                            <table width="100%">
                                <tr>
                                    <th :colspan="header.inner_items.length" class="text-xs-center">
                                        {{ header.text }}
                                    </th>
                                </tr>
                                <tr>
                                    <th v-for="(header_item,index) in header.inner_items" :key="index" :class="['column sortable grey-bg', pagination.descending ? 'desc' : 'asc',
                                                                                                                header_item.value === pagination.sortBy ? 'active' : '']"
                                        @click="changeSort(header_item.value)"
                                    >
                                        {{ header_item.text }}
                                        <v-icon small>keyboard_arrow_up</v-icon>
                                    </th>
                                </tr>
                            </table>
                        </th>
                    </template>
                </tr>
            </template>
            <template slot-scope="props" slot="items">
                <tr>
                    <td class="text-xs-left">{{ props.item.department }}</td>
                    <td class="text-xs-left">{{ props.item.tasks }}</td>
                    <td class="text-xs-left">{{ props.item.new_tasks }}</td>
                    <td class="text-xs-left">{{ props.item.not_overdue }}</td>
                    <td class="text-xs-left">{{ props.item.overdue }}</td>
                    <td class="text-xs-left">{{ props.item.finished }}</td>
                    <td class="text-xs-left">{{ props.item.test_passed }}</td>
                    <td class="text-xs-left">{{ props.item.test_not_passed }}</td>
                    <td class="text-xs-left">{{ props.item.test_average }}</td>
                </tr>
            </template>
        </v-data-table>
    </v-flex>
</template>

<script>
import {mapGetters} from 'vuex';
export default {
  props: {
    content: {
      type: Object,
    },
  },
  data() {
    return {
      pagination: {
        sortBy: 'name',
      },
    };
  },
  computed: {
    ...mapGetters('database/classification', [
      'list',
    ]),
  },
  methods: {
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },
  },
};
</script>

<style>

</style>
